<script setup lang="ts">import { toRef as _toRef } from 'vue';

import SaveSearchButton from '@/modules/common/SaveSearch/SaveSearchButton.vue';
import SaveSearchSelector from '@/modules/common/SaveSearch/SaveSearchSelector.vue';
import useSaveSearch from '@/modules/common/SaveSearch/saveSearch';
import type { Location } from 'vue-router';

interface FilterResetProps {
  filterQuantity: number
  searchDomain?: string
}

interface FilterResetEmits {
  (e: 'reset'): void;
}

const emit = defineEmits(["reset"]);

const props = defineProps({
  filterQuantity: null,
  searchDomain: { default: '' }
});

const __$temp_1 = (useSaveSearch(props.searchDomain)),
  deleteSearch = _toRef(__$temp_1, 'deleteSearch'),
  hasSearches = _toRef(__$temp_1, 'hasSearches'),
  items = _toRef(__$temp_1, 'items'),
  selectedSearch = _toRef(__$temp_1, 'selectedSearch'),
  saveSearch = _toRef(__$temp_1, 'saveSearch'),
  resetSelectedSearch = _toRef(__$temp_1, 'resetSelectedSearch');;

const handleDelete = (id: string) => {
  deleteSearch.value(props.searchDomain, id);
};

const handleSave = (name: string, query: Location['query']) => {
  saveSearch.value(name, query);
};

const handleReset = () => {
  emit('reset');
  resetSelectedSearch.value();
};

</script>

<template lang="pug">
.mb-2
  .d-flex.justify-space-between.mb-3.align-center( style="height: 36px;" )
    .d-flex.align-center
      b.body-1( class="classes" ) {{ $tc('common.words.filter', 2) }}
    v-spacer
    SaveSearchButton(
      v-if="searchDomain && filterQuantity"
      @save="handleSave"
    )
    SButton(
      v-if="filterQuantity"
      @click="handleReset"
      size="small"
      color="danger"
      variant="text"
      :text="$t('common.words.clear')"
      data-track="filter-reset-button" )
  SaveSearchSelector(
    v-if="searchDomain && hasSearches"
    v-model="selectedSearch"
    :items="items"
    @delete="handleDelete"
  )
</template>
